import axios, { AxiosInstance } from 'axios'

import axiosConfig from '@/api/fetch/config'
import interceptors from '@/api/fetch/interceptors'

const fetch: AxiosInstance = axios.create({
	...axiosConfig,
})

fetch.interceptors.request.use(
	interceptors.requestSuccess,
	interceptors.requestFail
)
fetch.interceptors.response.use(
	interceptors.responseSuccess,
	interceptors.responseFail
)

export default fetch
